<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Platform Guide
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Changelogs</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-clock-rotate-left me-1" style="color: #00A0C1;"></i>
                  Executive summary of platform updates, new security capabilities, and system enhancements.
               </small>
            </div>
         </div>
      </div>

      <Changelogs />
   </div>
</template>

<script>
import Changelogs from '@/components/ExtensionConfiguration/Changelogs/Changelogs.vue';

export default {
   components: {
      Changelogs,
   },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>
